export const ICONS = {
  AddChannel: 'add-channel',
  AddComment: 'add-comment',
  AnalyzeLink: 'analyze-link',
  Arrow: 'arrow',
  ArrowDown: 'arrow-down',
  ArrowRight: 'arrow-right',
  ArrowUp: 'arrow-up',
  Assess: 'assess',
  Activity: 'activity',
  Back: 'back',
  Notes: 'notes',
  Calendar: 'calendar',
  Checkmark: 'checkmark',
  CheckmarkDefault: 'CheckmarkDefault',
  Check: 'check',
  Clock: 'clock',
  Scissor: 'scissor',
  Overlay: 'overlay',
  Model: 'model',
  Tag: 'tag',
  Loader: 'loader',
  Monitor: 'monitor',
  TeamsLogo: 'teams-logo',
  Train: 'train',
  Timeperiod: 'timeperiod',
  ScaleExpand: 'scale-expand',
  ScaleShrink: 'scale-shrink',
  Views: 'views',
  Alert: 'alert',
  Group: 'group',
  Sort: 'sort',
  Settings: 'settings',
  Binary: 'binary',
  Indent: 'indent',
  OverlayActive: 'overlay-active',
  Indeterminate: 'indeterminate',
  JumpBack: 'jump-back',
  Chevron: 'chevron',
  Close: 'close',
  CloseX: 'close-x',
  CloseNew: 'close-new',
  ClosedEye: 'closed-eye',
  Delete: 'delete',
  Download: 'download',
  Edit: 'edit',
  Inbox: 'inbox',
  Investigate: 'investigate',
  InvestigateAll: 'investigate-all',
  Install: 'install',
  Envelope: 'envelope',
  Eye: 'eye',
  Folder: 'folder',
  Gear: 'gear',
  Kebab: 'kebab',
  List: 'list',
  Limits: 'limits',
  LimitAlert: 'limit-alert',
  AnomalyAlert: 'anomaly-alert',
  Stopwatch: 'stopwatch',
  Mute: 'mute',
  ListActive: 'list-active',
  Grid: 'grid',
  GridActive: 'grid-active',
  Home: 'home',
  Copy: 'copy',
  Dynamic: 'dynamic',
  RowDragHandle: 'row-drag-handle',
  ZoomIn: 'zoom-in',
  Undo: 'undo',
  ZoomOut: 'zoom-out',
  Plus: 'plus',
  Pin: 'pin',
  Search: 'search',
  SelectTrend: 'select-trend',
  Sparkline: 'sparkline',
  System: 'system',
  SystemDown: 'system-down',
  Minus: 'minus',
  Menu: 'menu',
  TooltipArrow: 'tooltip-arrow',
  Export: 'export',
  Bell: 'bell',
  Teams: 'teams',
  User: 'user',
  Comment: 'comment',
  Content: 'content',
  Info: 'info',
  Union: 'union',
  Upload: 'upload',
  Help: 'help',
  ThumbUp: 'thumb-up',
  ThumbDown: 'thumb-down',
  PanRight: 'pan-right',
  PanLeft: 'pan-left',
  Now: 'now',
  Opmode: 'opmode',
  BurgerMenu: 'burger-menu',
  Filter: 'filter',
  Spinner: 'spinner',
  Expand: 'expand',
  Collapse: 'collapse',
  TrendSearch: 'trend-search',
  PinSolid: 'pin-solid',
  PinOutline: 'pin-outline',
  StackIcon: 'stack-icon',
  Flag: 'flag',
  Share: 'export', // Share uses the export icon
  Archive: 'archive',
  Manage: 'manage',
};

export const GRADIENTS = {
  g1: 'g1',
  g2: 'g2',
  g3: 'g3',
  hover: 'hover-row',
  selected: 'selected-row',
  tooltipLine: 'tooltip-line',
  tagHover: 'tag-hover',
  tagHeaderHover: 'tag-header-hover',
  limits: 'limits',
};

export const SUB_SYSTEMS_SEARCH_PARAM = 'subsystems';
export const TAGS_SEARCH_PARAM = 'tagname';
export const ALERT_SEARCH_PARAM = 'alert';

export { default as timezones } from './timezones';
export type { TimeZone } from './timezones';

export * from './labeled-events';
